import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import CreateSession from './pages/CreateSession';
import SessionView from './pages/SessionView';
import EditSession from './pages/EditSession';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white font-rubik">
        <Header />
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/create" element={<CreateSession />} />
            <Route path="/session/:id" element={<SessionView />} />
            <Route path="/edit/:id" element={<EditSession />} />
          </Routes>
        </motion.div>
      </div>
    </Router>
  );
}

export default App;